import { defineComponent, reactive, computed } from 'vue';
import { Image2 } from '@hems/component';
import { DateHelper } from '@hems/util';
export default defineComponent({
    name: 'SimpleDateSectionPicker',
    components: { Image2 },
    props: {
        startDate: {
            type: String,
            required: true,
            default: '',
        },
        endDate: {
            type: String,
            required: true,
            default: '',
        },
    },
    emits: ['prev', 'next'],
    setup(props) {
        const state = reactive({
            formattingStartDate: computed(() => props.startDate === '' ? '' : DateHelper.getSimpleDateFormat(props.startDate, 'day')),
            formattingEndDate: computed(() => props.endDate === '' ? '' : DateHelper.getSimpleDateFormat(props.endDate, 'day')),
        });
        const dateText = computed(() => {
            if (state.formattingStartDate !== '' && state.formattingEndDate === '') {
                return `${state.formattingStartDate} - up to date`;
            }
            return `${state.formattingStartDate} - ${state.formattingEndDate}`;
        });
        return {
            state,
            dateText,
        };
    },
});
